import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { DealerSettingName } from '../../chat/interfaces/IDealerSettings';
import { PermissionsService } from '../../chat/services/permissions.service';

@Directive({
  selector: '[hasDealerSettings]',
  standalone: false,
})
export class HasDealerSettingsDirective {
  constructor(
    private permissionsService: PermissionsService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<unknown>
  ) {}

  @Input() set hasDealerSettings(setting: DealerSettingName) {
    if (this.permissionsService.checkDealerSetting(setting)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
